'use strict';
angular
    .module('websiteSignedModule', [
        'websiteSignedRouterModule',
        'editWebsiteCancelDraftMgrModule',
        'batchGeneratingModule',
        'batchMoveNewsModule',
        'websiteSignedServiceModule',
    ])
    .controller('websiteSignedCtrl', signed);
signed.$injector = [
    '$scope',
    'previewService',
    '$filter',
    '$q',
    '$stateParams',
    '$state',
    '$window',
    'editIsLock',
    'localStorageService',
    'trsHttpService',
    'initSingleSelecet',
    'editingCenterService',
    'modalDialog',
    'trsspliceString',
    'websiteService',
    'editcenterRightsService',
    'signedService',
    'storageListenerService',
    'globleParamsSet',
    'trsPrintService',
    'editRepetitiveBtnService',
    'newMediaService',
    'websiteConst',
];

/**
 * [description]
 */
function signed(
    $scope,
    previewService,
    $filter,
    $q,
    $stateParams,
    $state,
    $window,
    editIsLock,
    localStorageService,
    trsHttpService,
    initSingleSelecet,
    editingCenterService,
    modalDialog,
    trsspliceString,
    websiteService,
    editcenterRightsService,
    signedService,
    storageListenerService,
    globleParamsSet,
    trsPrintService,
    editRepetitiveBtnService,
    newMediaService,
    websiteConst
) {
    initStatus();
    initData();

    /**
     * [initStatus description] 批量移动成功，再次获取数据
     * @return {[type]} [description] null
     */
    $scope.$on('moveSuccess', function(event, data) {
        // alert(data);
        requestData();
    });

    /**
     * [initStatus description]初始化状态
     * @return {[type]} [description] null
     */
    function initStatus() {
        $scope.page = {
            CURRPAGE: 1,
            PAGESIZE: globleParamsSet.getPageSize(),
            ITEMCOUNT: 0,
            PAGECOUNT: 1,
        };
        $scope.childStatus = {
            // 图片数组的string
            checkString: 'DOC_PICTURELIST',
            // 图片数组中表示url地址的string
            picString: 'SRCPICURL',
            originPicUrl: 'SRCPICURL',
        };
        $scope.status = {
            isAllColumn: $state.params.channelid === '0',
            hasRequestBtnRights: {},
            showFixPosition: true,
            isESSearch: false,
            onlyMine: false,
            onlyCurChannel: true,
            btnRights: {},
            isFixed: false,
            siteid: $stateParams.siteid,
            hasChildren: $stateParams.hasChildren,
            icon: {
                noVideo: '0',
                noAudio: '0',
                noPic: '0',
            },
            detailMethodname: {
                1: 'getNewsDoc',
                2: 'getPicsDoc',
                3: 'getSpecialDoc',
                4: 'getLinkDoc',
            },
            copyCurrPage: 1,
            hiddenDraft: '1',
            hasFixed: false, // 包含固定位置的稿件
            draftType: {
                news: '1',
                atlas: '2',
                subject: '3',
                linkDoc: '4',
                video: '7',
            },
        };
        $scope.fixedPos = [];
        $scope.data = {
            ORIGINCHANNEL: [],
            items: [],
            trench: websiteConst.listenStroageKey,
            selectedArray: [],
            printResult: [],
            firstPageItemsLenth: 0,
            editPath: websiteService.getEditandPreviewPath().edit,
            previewPath: websiteService.getEditandPreviewPath().preview,
            id: {
                channelid: $stateParams.channelid,
                siteid: $stateParams.siteid,
            },
        };
        $scope.params = {
            serviceid: 'mlf_website',
            methodname: 'querySignedDoc',
            CurrPage: $scope.page.CURRPAGE,
            PageSize: $scope.page.PAGESIZE,
            ChannelId: $stateParams.channelid,
            SiteId: $stateParams.siteid,
            timeType: '',
            IsCurrentChnl: true,
            DocId: '',
        };

        // 监听未保存的专题分组，并删除
        $window.addEventListener('storage', function(e) {
            var draftInfo = localStorageService.get('websiteUnsavedGroup');
            if (draftInfo && draftInfo.specialGroupIds) {
                localStorageService.remove('websiteUnsavedGroup');
                // deleteUnsavedGroup(draftInfo).then(function (data) {
                //     console.log('删除分组成功！');
                // });
            }
        });
    }

    /**
     * [deleteUnsavedGroup description] 删除未保存的专题分组
     * @param  {[type]} draftInfo [description] 分组信息和稿件信息
     * @return {[type]}           [description]
     */
    function deleteUnsavedGroup(draftInfo) {
        var defer = $q.defer();
        var params;
        if (draftInfo.metadataid == '0') {
            params = {
                serviceid: 'mlf_tag',
                methodname: 'deleteTagsNoMetadata',
                TagIds: draftInfo.specialGroupIds,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                defer.resolve();
            });
        } else {
            params = {
                serviceid: 'mlf_tag',
                methodname: 'deleteSpecialTag',
                TagId: draftInfo.specialGroupIds,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                defer.resolve();
            });
        }
        return defer.promise;
    }

    /**
     * [initData description]初始化数据
     * @return {[type]} [description] null
     */
    function initData() {
        if (!angular.isDefined($stateParams.siteid)) {
            return;
        } // 如果没有站点，不进行初始化请求
        if (!angular.isDefined($stateParams.channelid)) {
            return;
        } // 如果没有栏目，不进行初始化请求
        if (!$scope.status.isAllColumn){
            saveVideoMode();
            editcenterRightsService.initWebsiteListBtn('web.yiqianfa', $stateParams.channelid).then(function(rights) {
                $scope.status.btnRights = rights;
            });
            editingCenterService.getChannelDetail($stateParams.channelid).then(function(data) {
                $scope.data.getChannelDetail = data;
            });
        } else {
            // 在所有栏目下则不传ChannelId
            delete $scope.params.ChannelId;
            $scope.params.IsLoadAllChnl = true;
            $scope.status.btnRights = websiteService.initQianFaBtnRight();
        }
        dropList();
        // requestData().then(function () {
        //     initFixedPos();
        //     getVideoInfo();
        //     editRepetitiveBtnService.dealListImg($scope.data.items);
        //     editRepetitiveBtnService.multiSignedMark($scope.data.items);
        // });
        listenStorage();
    }

    // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
    $scope.requestData = function() {
        requestData().then(function () {
            initFixedPos();
            getVideoInfo();
            editRepetitiveBtnService.dealListImg($scope.data.items);
            editRepetitiveBtnService.multiSignedMark($scope.data.items);
        });
    };

    /**
     * [saveVideoMode description] 记录视频模式
     * @return {[type]} [description]
     */
    function saveVideoMode() {
        let videoMode = localStorageService.get('websiteListVideomode') == '1';
        if (videoMode) {
            $scope.data.selectedDocType = {
                name: '视频',
                value: 7,
            };
            $scope.params.docType = 7;
        }
        $scope.$watch('data.selectedDocType', (newV, oldV) => {
            if (newV.value == 7) {
                localStorageService.set('websiteListVideomode', '1');
            } else {
                localStorageService.set('websiteListVideomode', '0');
            }
        });
    }

    /**
     * [videoMode description] 视频模式
     * @return {[type]} [description]
     */
    $scope.videoMode = function() {
        if ($scope.data.selectedDocType.value == 7) {
            $scope.data.selectedDocType = angular.copy($scope.data.docTypeArray[0]);
        } else {
            $scope.data.selectedDocType = {
                name: '视频',
                value: '7',
            };
        }
        $scope.queryByDropdown('docType', $scope.data.selectedDocType.value);
    };

    /**
     * [pageChanged description]初始化数据
     * @return {[type]} [description] null
     */
    $scope.pageChanged = function () {
        $scope.params.CurrPage = $scope.page.CURRPAGE;
        $scope.status.copyCurrPage = $scope.page.CURRPAGE;
        requestData();
    };

    /* 跳转指定页面*/
    $scope.jumpToPage = function() {
        if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
            $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
        }
        $scope.params.CurrPage = $scope.status.copyCurrPage;
        $scope.page.CURRPAGE = $scope.params.CurrPage;
        requestData();
    };

    /**
     * [selectPageNum description]选择单页分页条数
     * @return {[type]} [description]
     */
    $scope.selectPageNum = function () {
        $scope.params.CurrPage = $scope.page.CURRPAGE;
        $scope.params.PageSize = $scope.page.PAGESIZE;
        $scope.status.copyCurrPage = 1;
        requestData();
    };

    /**
     * [selectAll description]初始化数据
     * @return {[type]} [description] null
     */
    $scope.selectAll = function() {
        $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        checkHasNoFixed();
    };

    /**
     * [selectDoc description]单选
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.selectDoc = function(item) {
        var index = $scope.data.selectedArray.indexOf(item);
        if (index < 0) {
            $scope.data.selectedArray.push(item);
        } else {
            $scope.data.selectedArray.splice(index, 1);
        }
        checkHasNoFixed();
        judgeAuthority(item);
    };

    /**
     * [selectDoc description]
     * @return  {[type]}        [return description]
     */
    function checkHasNoFixed() {
        for (let i = 0; i < $scope.data.selectedArray.length;i++) {
            if ($scope.data.selectedArray[i].GDORDER == '0' || !$scope.data.selectedArray[i].GDORDER) {
                $scope.status.showFixPosition = true;
                break;
            } else {
                $scope.status.showFixPosition = false;
            }
        }
        // $scope.status.showFixPosition = $scope.status.hasCheckNoFixed ? true : false;
    }

    /**
     * [judgeAuthority description]获取勾选权限
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    function judgeAuthority(item) {
        if (!$scope.status.isAllColumn) {return;}
        if ($scope.data.selectedArray.length === 0) {
            $scope.status.btnRights = websiteService.initQianFaBtnRight();
            return ;
        }

        if (!$scope.status.hasRequestBtnRights[item.CHANNELID]){
            $scope.loadingPromise = editcenterRightsService.initWebsiteListBtn('web.yiqianfa', item.CHANNELID).then(function(rights) {
                $scope.status.hasRequestBtnRights[item.CHANNELID] = rights;
                $scope.status.btnRights = editcenterRightsService.permissionIntersection($scope.data.selectedArray, $scope.status.hasRequestBtnRights);
            });
        } else {
            $scope.status.btnRights = editcenterRightsService.permissionIntersection($scope.data.selectedArray, $scope.status.hasRequestBtnRights);
        }


        // 当前是否是所有栏目 是则判断item的栏目id 是否是请求过的（是否在对象key中），没有则请求权限 {123：obj}、
        // 取对象交集作为权限
    }

    /**
     * [share description] 共享操作
     * @param  {[type]} item [description]  如果传入代表单个稿件收藏，不传代表批量操作
     * @return {[type]}      [description]
     */
    $scope.share = function(item) {
        $scope.status.isESSearch = false;
        var chnlDocIds, metaDataIds;
        if (!!item) {
            chnlDocIds = item.CHNLDOCID;
            metaDataIds = item.METADATAID;
        } else {
            chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
            metaDataIds = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
        }
        share(chnlDocIds, metaDataIds);
    };

    /**
     * [share description]共享方法
     * @param  {[type]} chnldocids  [description] 多个chnldocid 以逗号隔开
     * @param  {[type]} metadataids [description] 多个metadataid  以逗号隔开
     * @return {[type]}             [description]
     */
    function share(chnldocids, metadataids) {
        editingCenterService.share(function(data) {
            data.serviceid = 'mlf_websiteoper';
            data.methodname = 'doShareYIQIANFA';
            data.ChnlDocIds = chnldocids;
            data.MetaDataIds = metadataids;
            data.ChannelId = $stateParams.channelid;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), data, 'post').then(function(data) {
                modalDialog.alertType('操作成功', '', 'success', false);
                requestData();
            });
        });
    }

    /**
     * [fixed description] 稿件固定位置
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.fixed = function () {
        if ($scope.status.showFixPosition === false) {
            modalDialog.confirmModal('取消固定位置', '是否确认取消固定位置', function() {
                var params = {
                    serviceid: 'mlf_appoper',
                    methodname: 'fixedPositionOfMeta',
                    ChannelId: $stateParams.channelid,
                    ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                    IsFixedPos: false
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
                    modalDialog.alertType('操作成功', '', 'success', false);
                    requestData();
                });
            });
            return;
        }
        if ($scope.data.selectedArray.length > 50) {
            modalDialog.alertType('您已超出允许选择固定的稿件数量,只能固定50条', '', 'info', false);
            return;
        }
        var params = {
            serviceid: 'mlf_website',
            methodname: 'querySignedDocForFixed',
            ChannelId: $stateParams.channelid,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
            editingCenterService
                .fixPositionModel(
                    {
                        selectedArray: angular.copy($scope.data.selectedArray),
                        items: angular.copy(data.DATA),
                        firstPageItemsLenth: angular.copy($scope.data.firstPageItemsLenth),
                    },
                    'website'
                )
                .then(
                    (res) => {
                        requestData();
                    },
                    function() {
                        requestData();
                    }
                );
        });
    };

    /**
     * [sign description]多签
     * @return {[type]} [description] null
     */
    $scope.sign = function(item) {
        $scope.status.isESSearch = false;
        var selectedArray;
        if (!!item) {
            selectedArray = [item];
        } else {
            selectedArray = $scope.data.selectedArray;
        }
        // batSign(selectedArray);
        editRepetitiveBtnService.multipleChannelSign(selectedArray, 3).then(
            () => {
                requestData();
            },
            () => {
                requestData();
            }
        );
    };

    function examSelectedArray(name) {
        var flag = true;
        if ($scope.data.selectedArray.length > 1) {
            flag = false;
            modalDialog.alertType(name + '失败', name + '操作只能选择单篇稿件', 'error');
        }
        if ($scope.data.selectedArray[0].GDORDER > 0) {
            flag = false;
            modalDialog.alertType(name + '失败', name + '操作不包含已固定稿件', 'error');
        }
        return flag;
    }

    /**
     * [stick description]置顶
     * @return {[type]} [description] null
     */
    $scope.stick = function() {
        $scope.status.isESSearch = false;
        if ($scope.data.getChannelDetail.HASCHILDREN === '1' && !$scope.params.IsCurrentChnl) {
            modalDialog.alertType('请选择“只看当前栏目”', '', 'warning', false);
            return;
        }
        // if ($scope.data.selectedArray[0].GDORDER > 0) {
        //     modalDialog.alertType('该文档已固定位置,无法进行置顶操作', '', 'warning', false);
        //     return;
        // }
        if ($scope.data.selectedArray.length !== 1) {
            modalDialog.alertType('请选择单篇稿件', '', 'warning', false);
            return;
        }
        if ($scope.data.selectedArray[0].GDORDER > 0) {
            modalDialog.alertType('该文档已固定位置,无法进行置顶操作', '', 'warning', false);
            return;
        }
        var topFlag = $scope.data.selectedArray[0].DOCORDERPRI === '0' ? 2 : 0;
        modalDialog.confirmModal(
            topFlag === 2 ? '置顶？' : '取消置顶？',
            topFlag === 2 ? '确认要置顶该稿件？' : '确定要取消置顶该稿件？',
            function() {
                var params = {
                    serviceid: 'mlf_websiteoper',
                    methodname: 'setTopDocument',
                    ChannelId: parseInt($scope.data.selectedArray[0].CHNLID),
                    DocumentId: $scope.data.selectedArray[0].METADATAID,
                    TargetDocumentId: $scope.data.items[0].DOCORDERPRI === '0' ? '0' : $scope.data.items[0].METADATAID,
                    TopFlag: topFlag,
                    Position: 1,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function() {
                        requestData();
                    },
                    function() {
                        requestData();
                    }
                );
            }
        );

        /* var isSingleDraft = examSelectedArray('置顶');
        if (isSingleDraft === true) {
            websiteService.stick($scope.data.selectedArray, $stateParams.channelid, {
                serviceid: "mlf_websiteoper",
                methodname: "sortTopedMetaDatas",
                _serviceid: "mlf_websiteoper",
                _methodname: "querySetTopInfo",
                ChnlDocId: $scope.data.selectedArray[0].CHNLDOCID
            }, $scope.page.PAGESIZE, function() {
                modalDialog.alertType("设置置顶成功", "", "success", false, function() {
                    requestData();
                });
            });
        }*/
    };

    /**
     * [rank description]排序
     * @return {[type]} [description] null
     */
    $scope.rank = function() {
        $scope.status.isESSearch = false;
        var isSingleDraft = examSelectedArray('排序');
        if (isSingleDraft === true) {
            var channelid = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLID', ',');
            editingCenterService.rank(
                channelid,
                $scope.data.selectedArray,
                $scope.fixedPos,
                {
                    serviceid: 'mlf_websiteoper',
                    methodname: 'sortSetUpMetaDatas',
                },
                function(data) {
                    modalDialog.alertType('排序成功', '', 'success', false);
                    requestData();
                }
            );
        }
    };

    /**
     * [copyDraft description]复制
     * @return {[type]} [description] null
     */
    $scope.copyDraft = function(item) {
        $scope.status.isESSearch = false;
        var selectedArray;
        if (!!item) {
            selectedArray = [item];
        } else {
            selectedArray = $scope.data.selectedArray;
        }
        copyDraft(selectedArray);
    };

    /**
     * [moveDraft description移动
     * @return {[type]} [description] null
     */
    $scope.moveDraft = function(item) {
        $scope.status.isESSearch = false;
        if (!!item) {
            if (item.GDORDER) {
                modalDialog.alertType('所选稿件包含已固定稿件，请先取消固定', '', 'info', false);
                return;
            }
            moveDraft([item]);
        } else {
            let flag = true;
            angular.forEach($scope.data.selectedArray, function(_item) {
                if (_item.GDORDER) {
                    modalDialog.alertType('所选稿件包含已固定稿件，请先取消固定', '', 'info', false);
                    flag = false;
                    return;
                }
            });
            if (flag) {
                moveDraft($scope.data.selectedArray);
            }
        }
    };

    /**
     * [collect description]收藏
     * @return {[type]} [description] null
     */
    $scope.collect = function(item) {
        if (editcenterRightsService.judgeCanBeCollected($scope.data.selectedArray)) {
            modalDialog.alertType('只能收藏新闻、图集、视频或者链接稿', '', 'warning', 'confirm', '');
            return;
        }
        $scope.status.isESSearch = false;
        modalDialog.alertType('', '确认收藏稿件?', 'ask', true, function() {
            var chnlDocIds;
            if (!!item) {
                chnlDocIds = item.CHNLDOCID;
            } else {
                chnlDocIds = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
            }
            collectDraft(chnlDocIds);
        });
    };

    /**
     * [listenStorage description]监听本地缓存
     * @return {[promise]} [description] promise
     */
    function listenStorage() {
        storageListenerService.listenWebsite(function() {
            $scope.status.isESSearch = false;
            requestData();
            storageListenerService.removeListener('website');
        }, $scope);
    }

    /**
     * [dropList description]
     *
     * @return  {[type]}  [return description]
     */
    function dropList() {
        $scope.data.docTypeArray = initSingleSelecet.websiteDocType();
        $scope.data.selectedDocType = angular.copy($scope.data.docTypeArray[0]);
        $scope.data.timeTypeArray = initSingleSelecet.chooseTimeType();
        $scope.data.selectedTimeType = angular.copy($scope.data.timeTypeArray[0]);
        // 初始化搜索框边的下拉框
        $scope.data.iWoAll = initSingleSelecet.iWoEntire();
        $scope.data.iWoAllSelected = angular.copy($scope.data.iWoAll[0]);
        // 排序方式
        $scope.sortTypeJsons = initSingleSelecet.sortType();
        $scope.sortType = angular.copy($scope.sortTypeJsons[1]);
        // editingCenterService.dealStorage($scope);
    }

    /**
     * [requestData description]
     *
     * @return  {[type]}  [return description]
     */
    function requestData() {
        // $scope.data.items = [];
        let defer = $q.defer();
        var params = $scope.status.isESSearch ? getESSearchParams() : $scope.params;
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
            var ListItems = data.DATA;
            $scope.data.items = ListItems;
            if ($scope.page.CURRPAGE === 1) {
                $scope.data.firstPageItemsLenth = ListItems.length;
            }
            if ($scope.data.selectedDocType) {
                if ($scope.data.selectedDocType.value && $scope.data.selectedDocType.value === '2') { // && $scope.status.hasphotoflag === true
                    $scope.status.hasphoto = true;
                } else {
                    $scope.status.hasphoto = false;
                }
            }
            !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
            $scope.data.selectedArray = [];
            // requestListImg(ListItems).then(function (data) {
            //     angular.forEach(ListItems, function (value, key) {
            //         value.ALLIMG = data[value.METADATAID];
            //     });
            // });
            // initFixedPos();
            // getVideoInfo();
            defer.resolve();
        });
        return defer.promise;
    }

    /**
     * [getVideoInfo description] 获取稿件视频信息
     * @return {[type]} [description]
     */
    function getVideoInfo() {
        $scope.data.videoInfo = '';
        if ($scope.data.selectedDocType.value != 7) {
            return;
        }
        let deffer = $q.defer();
        let params = {
            serviceid: 'mlf_website',
            methodname: 'queryAllAppendixVideo',
            MetadataIds: $scope.data.items.map((item) => item.METADATAID).join(','),
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
            $scope.data.videoInfo = data;
        });
    }

    /**
     * [playVideo description] 播放视频
     * @param  {[type]} item [description] 稿件信息
     * @return {[type]}      [description]
     */
    $scope.playVideo = function(item) {
        let videoInfo = $scope.data.videoInfo[item.METADATAID];
        previewService.videoPlayer(videoInfo.AUDIOVIDEOID, '3', item.TITLE);
    };

    /**
     * [requestListImg description]查询列表图示
     *
     * @param   {[type]}  items  [items description]
     *
     * @return  {[type]}         [return description]
     */
    function requestListImg(items) {
        var defer = $q.defer();
        if (!items || items.length < 1) {
            defer.resolve([]);
        } else {
            var params = {
                serviceid: 'mlf_myrelease',
                methodname: 'queryAllImgLogo',
                metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                defer.resolve(data);
            });
        }
        return defer.promise;
    }

    /**
    * [pushBar description]推首页
    *
    * @param   {[type]}  item  [item description]
    *
    * @return  {[type]}        [return description]
    */
    $scope.pushBar = function(item) {
        $scope.status.isESSearch = false;
        websiteService.pushBar(
            '推首页（北方网）',
            function(result) {
                var params = angular.copy(result);
                params.chnldocIds = trsspliceString.spliceString(item ? [item] : $scope.data.selectedArray, 'CHNLDOCID', ',');
                promptRequest(params, '推首页成功');
            },
            $scope.data.selectedArray
        );
    };

    /**
     * [pushBarToMlf description]推首页到媒立方
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.pushBarToMlf = function(item) {
        $scope.status.isESSearch = false;
        websiteService.pushBarToMlf(
            '推首页',
            function(result) {
                var params = angular.copy(result);
                params.chnldocIds = trsspliceString.spliceString(item ? [item] : $scope.data.selectedArray, 'CHNLDOCID', ',');
                promptRequest(params, '推首页成功');
            },
            $scope.data.selectedArray
        );
    };

    /**
     * [promptRequest description]具体操作数据请求成功后刷新列表
     * @param  {[obj]} params [description]请求参数
     * @param  {[string]} info   [description]提示语
     * @return {[type]}        [description]
     */
    function promptRequest(params, info) {
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            modalDialog.alertType(info, '', 'success', false);
            requestData();
        });
    }

    /**
     * [revoke description]撤稿
     * @param   {[type]}  item  [item description]
     * @return  {[type]}        [return description]
     */
    $scope.revoke = function() {
        $scope.status.isESSearch = false;
        rejection();
    };

    /**
     * [rejection description]撤稿
     * @return  {[type]}                    [return description]
     */
    function rejection() {
        $scope.loadingPromise = newMediaService.retraction($scope, websiteConst.withdrawrejection);
    }

    /**
     * [collectDraft description]收藏
     * @param   {[type]}  array  [array description]
     * @return  {[type]}         [return description]
     */
    function collectDraft(array) {
        var temp = $filter('pick')($scope.data.selectedArray, $scope.filterChannelId);
        if (temp.length === $scope.data.selectedArray.length) {
            var params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'collectionYIQIANFADocs',
                ChannelId: $scope.data.selectedArray[0].CHANNELID,
                ChnlDocIds: array,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                function() {
                    modalDialog.alertType('收藏成功', '', 'success', false);
                },
                function() {
                    $scope.data.selectedArray = [];
                }
            );
        } else {
            modalDialog.alertType('收藏失败', '所选稿件不属于同一栏目', 'error', false);
            $scope.data.selectedArray = [];
        }
    }

    /**
     * [queryByDropdown description]根据稿件类型查询
     *
     * @param   {[type]}  key    [key description]
     * @param   {[type]}  value  [value description]
     *
     * @return  {[type]}         [return description]
     */
    $scope.queryByDropdown = function (key, value) {
        $scope.params[key] = value;
        $scope.status.copyCurrPage = $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
        if (key == 'timeType') {
            $scope.params.OperTimeStart = $scope.data.fromdate;
            $scope.params.OperTimeEnd = $scope.data.untildate;
            $scope.params[key] = null;
        }
        if (key === 'DocType' && value === '2') {
            $scope.status.hasphotoflag = true;
        }
        requestData();
    };

    /**
     * [isOnlyMine description]只看我的
     * @return {Boolean} [description] null
     */
    $scope.isOnlyMine = function () {
        $scope.status.copyCurrPage = $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
        $scope.status.onlyMine = !$scope.status.onlyMine;
        $scope.params.isOnlyMine = $scope.status.onlyMine;
        requestData();
    };

    /**
     * [isOnlyCurChannel description]只看当前栏目
     * @return {Boolean} [description] null
     */
    $scope.isOnlyCurChannel = function () {
        $scope.status.copyCurrPage = $scope.params.CurrPage = $scope.page.CURRPAGE = '1';
        $scope.params.IsCurrentChnl = !$scope.params.IsCurrentChnl;
        requestData().then(function () {
            if ($scope.params.IsCurrentChnl) {
                initFixedPos();
            } else {
                $scope.fixedPos = [];
            }
            $scope.status.isFixed = !$scope.status.isFixed;
        });
    };

    /**
     * [goToDetail description]图集模式跳转细览页
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.goToDetail = function(item){
        $scope.websitePreview(item);
        var params = {
            wzchannelid: item.CHNLID,
            wzchnldocid: item.CHNLDOCID,
            wzsiteid: $scope.status.siteid,
            wzmetadataid: item.METADATAID,
            wzplatform: 2,
            wztypeid: item.DOCTYPEID
        };
        var url = $state.href('websitePreviewAll', params);
        window.open(url);
    };

    /**
     * [copyDraft description]复制稿件
     *
     * @param   {[type]}  array  [array description]
     *
     * @return  {[type]}         [return description]
     */
    function copyDraft(array) {
        var isCurrChnl = true;
        for (var i = 0; i < array.length; i++) {
            if (array[i].CHNLID != $stateParams.channelid) {
                isCurrChnl = false;
                break;
            }
        }
        if (!isCurrChnl) {
            modalDialog.alertType('无法复制', '不能对子栏目的稿件进行复制操作', 'error', false, function() {
                return;
            });
        } else {
            websiteService.batChooseChnl('复制稿件', $stateParams.siteid, 3, function(data) {
                var params = {
                    serviceid: 'mlf_websiteoper',
                    methodname: 'copyYIQIANFADoc',
                    ChannelId: $stateParams.channelid,
                    MetaDataIds: trsspliceString.spliceString(array, 'METADATAID', ','),
                    ChannelIds: data.ChannelIds,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('复制稿件成功', '', 'success', false, function() {
                        $scope.data.selectedArray = [];
                        requestData();
                    });
                });
            });
        }
    }

    /**
     * [batSign description]多签
     *
     * @param   {[type]}  items  [items description]
     *
     * @return  {[type]}         [return description]
     */
    function batSign(items) {
        var temp = $filter('pick')(items, $scope.filterChannelId);
        if (temp.length === items.length) {
            websiteService.batChooseChnl('多签', $stateParams.siteid, 3, function(data) {
                var params = {
                    serviceid: 'mlf_websiteoper',
                    methodname: 'transmitDoc',
                    ChnlDocIds: trsspliceString.spliceString(items, 'CHNLDOCID', ','),
                    ChannelIds: data.ChannelIds,
                    CurrChnlId: $scope.data.selectedArray[0].CHANNELID,
                    isLink: data.selectedRadio,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        modalDialog.alertType('多签成功', '', 'success', false, function() {
                            requestData();
                        });
                    },
                    function() {
                        requestData();
                    }
                );
            });
            // { enumValue: { '是': false, '否': true }, label: '是否镜像引用', defaultValue: '否' }
        } else {
            modalDialog.alertType('多签失败', '所选稿件不属于同一栏目', 'error', false);
            $scope.data.selectedArray = [];
        }
    }

    /**
     * [filterChannelId description]栏目ID过滤器
     * @param  {[obj]} elm [description]传入的值
     * @return {[type]}     [description]
     */
    $scope.filterChannelId = function(elm) {
        if (angular.isDefined(elm.CHANNELID)) {
            return elm.CHANNELID == $scope.data.selectedArray[0].CHANNELID;
        }
    };

    /**
     * [moveDraft description]移动
     *
     * @param   {[type]}  items  [items description]
     *
     * @return  {[type]}         [return description]
     */
    function moveDraft(items) {
        var temp = $filter('pick')(items, $scope.filterChannelId);
        if (temp.length === items.length) {
            var channelids = trsspliceString.spliceString(items, 'CHANNELID', ',');
            websiteService.singleChooseChnl('移动稿件', $stateParams.siteid, $stateParams.channelid, channelids, 3, function(data) {
                var params = {
                    serviceid: 'mlf_websiteoper',
                    methodname: 'moveYIQIANFADoc',
                    SrcChannelId: items[0].CHANNELID,
                    ChnlDocIds: trsspliceString.spliceString(items, 'CHNLDOCID', ','),
                    ToChannelId: data.channelid,
                    moveMode: 0,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('稿件移动成功', '', 'success', false, function() {
                        requestData();
                    });
                });
            });
        } else {
            modalDialog.alertType('稿件移动失败', '所选稿件不属于同一栏目', 'error', false);
            $scope.data.selectedArray = [];
        }
    }

    /**
     * [showVersionTime description]展示操作日志和流程版本
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.showVersionTime = function(item) {
        editingCenterService.getVersionTime(item, false);
    };

    /**
     * [fullTextSearch description]全文检索
     *
     * @param   {[type]}  ev  [ev description]
     *
     * @return  {[type]}      [return description]
     */
    $scope.fullTextSearch = function(ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            if ($scope.data.iWoAllSelected.value == 'DocID') {
                $scope.status.isESSearch = false;
                $scope.params.DocId = $scope.keywords;
            } else {
                $scope.status.isESSearch = true;
            }
            $scope.page.CURRPAGE = 1;
            requestData();
        }
    };

    /**
     * [getESSearchParams description]设置ES检索参数
     * @return {[json]} [description] 参数对象
     */
    function getESSearchParams() {
        var esParams = {
            serviceid: 'mlf_hybasesearch',
            methodname: 'queryForWebSiteSignedDoc',
            searchParams: {
                PAGESIZE: $scope.page.PAGESIZE + '',
                PAGEINDEX: $scope.page.CURRPAGE + '',
                searchFields: [
                    {
                        searchField: $scope.data.iWoAllSelected.value,
                        keywords: $scope.keywords ? $scope.keywords : '',
                    },
                    {
                        searchField: 'docType',
                        keywords: $scope.data.selectedDocType ? $scope.data.selectedDocType.value : '',
                    },
                    {
                        searchField: 'timeType',
                        keywords:
                            angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                ? $scope.data.fromdate + ',' + $scope.data.untildate
                                : $scope.data.selectedTimeType.value,
                    },
                    {
                        searchField: 'isOnlyCurChannel',
                        keywords: $scope.params.IsCurrentChnl,
                    },
                    {
                        searchField: 'isOnlyMine',
                        keywords: $scope.status.onlyMine,
                    },
                    {
                        searchField: 'channelid',
                        keywords: $stateParams.channelid,
                    },
                    {
                        searchField: '_sort',
                        keywords: $scope.sortType.value,
                    },
                ],
            },
        };
        // 所有栏目下  不传channelid 传siteid
        if ($scope.status.isAllColumn){
            esParams.searchParams.searchFields[5] = {
                searchField: 'siteid',
                keywords: $stateParams.siteid,
            };
            $scope.status.btnRights = websiteService.initQianFaBtnRight();
        }
        esParams.searchParams = JSON.stringify(esParams.searchParams);
        return esParams;
    }

    /**
     * [dragoverCallback description]拖拽
     *
     * @param   {[type]}  event     [event description]
     * @param   {[type]}  index     [index description]
     * @param   {[type]}  external  [external description]
     * @param   {[type]}  type      [type description]
     *
     * @return  {[type]}            [return description]
     */
    $scope.dragoverCallback = function(event, index, external, type) {
        // console.log("drag from "+index);
        if ($scope.data.items[index].GDORDER) {
            return false;
        }
        return true;
    };
    $scope.dragStart = function(event, item, index) {
        $scope.status.dragSelectedItem = item;
        $scope.status.dragSelectedItem.index = index;
    };

    /**
     * [dropCallback description] 拖拽
     *
     * @param   {[type]}  event        [event description]
     * @param   {[type]}  index        [index description]
     * @param   {[type]}  item         [item description]
     * @param   {[type]}  external     [external description]
     * @param   {[type]}  type         [type description]
     * @param   {[type]}  allowedType  [allowedType description]
     *
     * @return  {[type]}               [return description]
     */
    $scope.dropCallback = function(event, index, item, external, type, allowedType) {
        console.log('drop at ' + (index + 1)); // 落下的位置
        if ($scope.fixedPos.indexOf(index + 1) >= 0) {
            modalDialog.alertType('不可拖拽至已固定位置', '', 'info', false);
            return null;
        }
        if (item.DOCORDERPRI !== '0' && !item.GRORDER) {
            topDrag($scope.status.dragSelectedItem, index);
        } else if (!item.GDORDER) {
            if (index !== $scope.data.items.length && $scope.data.items[index].DOCORDERPRI !== '0') {
                modalDialog.alertType('普通稿件不能与置顶稿件混合排序', '', 'info', false);
                requestData();
                return;
            }
            commonDrag($scope.status.dragSelectedItem, index);
        }
        return item;
    };

    /**
     * [topDrag description]置顶拖拽排序
     *
     * @param   {[type]}  item   [item description]
     * @param   {[type]}  index  [index description]
     *
     * @return  {[type]}         [return description]
     */
    function topDrag(item, index) {
        if ($scope.data.items[item.index > index ? index : index - 1].DOCORDERPRI === '0') {
            modalDialog.alertType('置顶稿件不能与普通稿件混合排序', '', 'info', false);
            requestData();
            return;
        }
        var params = {
            serviceid: 'mlf_websiteoper',
            methodname: 'setTopDocument',
            ChannelId: parseInt(item.CHANNELID),
            DocumentId: item.METADATAID,
            TargetDocumentId: item.index > index ? $scope.data.items[index].METADATAID : $scope.data.items[index - 1].METADATAID,
            TopFlag: 3,
            Position: item.index > index ? 1 : 0,
        };
        modalDialog.alertType(
            '位置调整',
            '确定调整位置么？',
            'info',
            true,
            function() {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        requestData();
                    },
                    function(data) {}
                );
            },
            function() {
                requestData();
            }
        );
    }

    /**
     * [commonDrag description]普通拖拽
     *
     * @param   {[type]}  item       [item description]
     * @param   {[type]}  trueIndex  [trueIndex description]
     *
     * @return  {[type]}             [return description]
     */
    function commonDrag(item, trueIndex) {
        $scope.status.orderParams = {
            serviceid: 'mlf_websiteoper',
            methodname: 'sortPositionMetaDatas',
            ChannelId: $stateParams.channelid,
            FromChnlDocId: item.CHNLDOCID,
        };
        $scope.status.orderParams.Position = 1;
        if (angular.isDefined($scope.data.items[trueIndex])) {
            $scope.status.orderParams.ToChnlDocId = $scope.data.items[trueIndex].CHNLDOCID;
            modalDialog.alertType(
                '位置调整',
                '确定调整位置么？',
                'info',
                true,
                function() {
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.orderParams, 'post').then(
                        function(data) {
                            requestData();
                        },
                        function(data) {}
                    );
                },
                function() {
                    requestData();
                }
            );
        } else {
            $scope.status.orderParams.ToChnlDocId = $scope.data.items[trueIndex - 1].CHNLDOCID;
            modalDialog.alertType(
                '位置调整',
                '确定调整位置么？',
                'info',
                true,
                function() {
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.orderParams, 'post').then(
                        function(data) {
                            $scope.status.orderParams.Position = 0;
                            $scope.status.orderParams.FromChnlDocId = $scope.data.items[$scope.data.items.length - 1].CHNLDOCID;
                            $scope.status.orderParams.ToChnlDocId = $scope.data.items[$scope.data.items.length - 2].CHNLDOCID;
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.orderParams, 'post').then(function(data) {
                                requestData();
                            });
                        },
                        function(data) {}
                    );
                },
                function() {
                    requestData();
                }
            );
        }
    }
    // h5拖拽结束
    /**
     * [outSending description]外发
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.outSending = function(item) {
        if (checkDraftType($scope.status.draftType.video)) {
            modalDialog.alertType('所选稿件中含有视频稿，无法外发', '', 'error', 'confirm');
            return;
        }
        $scope.status.isESSearch = false;
        editingCenterService.outSending('', function(result) {
            outSendingDraft(result.selectItems, item);
        });
    };

    /**
     * [outSendingDraft description]外发
     *
     * @param   {[type]}  items  [items description]
     * @param   {[type]}  item   [item description]
     *
     * @return  {[type]}         [return description]
     */
    function outSendingDraft(items, item) {
        var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
        var draftids = trsspliceString.spliceString(item ? [item] : $scope.data.selectedArray, 'METADATAID', ',');
        var params = {
            serviceid: 'mlf_mailoutgoingOper',
            methodname: 'webYiQianFaSendEmail',
            Emails: userids,
            MetaDataIds: draftids,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
            function(data) {
                modalDialog.alertType('邮件外发成功', '', 'success', false, function() {
                    requestData();
                });
            },
            function() {
                $scope.data.selectedArray = [];
            }
        );
    }

    /**
     * [moreSign description]请求多签稿件
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.draftPublish = function(item) {
        $scope.status.isESSearch = false;
        editingCenterService.draftPublish(item.CHNLDOCID);
    };

    /**
     * [moreSign description]请求多签稿件
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.moreSign = function(item) {
        $scope.status.isESSearch = false;
        signedService.indexSign(item, function() {});
    };

    /**
     * [isLockEdit description]编辑前解锁
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.isLockEdit = function(item) {
        $scope.status.isESSearch = false;
        editIsLock.isLock(item, 2).then(function(data) {
            var editPath = $scope.data.editPath[item.DOCTYPEID];
            var editParams = {
                wzchannelid: item.CHANNELID,
                wzchnldocid: item.CHNLDOCID,
                wzmetadataid: item.METADATAID,
                wzsiteid: $stateParams.siteid,
                wzplatform: 2,
            };
            var editUrl = $state.href(editPath, editParams);
            if (data.ISLOCK == 'false') {
                $window.open(editUrl);
            } else {
                editIsLock.checkUnlockPermissions(item, data).then(function() {
                    $window.open(editUrl);
                });
            }
        });
    };

    /**
     * [printBtn description：打印]
     * @return  {[type]}          [return description]
     */
    $scope.printBtn = function() {
        if (checkDraftType($scope.status.draftType.subject) || checkDraftType($scope.status.draftType.video)) {
            modalDialog.alertType('所选稿件中有专题稿或视频稿，无法打印', '', 'error', 'confirm');
            return;
        }
        $scope.status.isESSearch = false;
        angular.forEach($scope.data.selectedArray, function(value, key) {
            requestPrintData(value);
        });
    };

    /**
     * [checkDraftType description]检查是否选中了某一类型的稿件
     *
     * @param   {[type]}  typeId  [typeId description]
     *
     * @return  {[type]}          [return description]
     */
    function checkDraftType(typeId) {
        var flag = false;
        for (var i = 0; i < $scope.data.selectedArray.length; i++) {
            if ($scope.data.selectedArray[i].DOCTYPEID == typeId) {
                flag = true;
                break;
            }
        }
        return flag;
    }

    /**
     * [requestPrintData description]打印请求详情
     *
     * @param   {[type]}  item     [item description]
     * @param   {[type]}  version  [version description]
     *
     * @return  {[type]}           [return description]
     */
    function requestPrintData(item, version) {
        var params = {
            serviceid: 'mlf_website',
            methodname: $scope.status.detailMethodname[item.DOCTYPEID],
            MetaDataId: item.METADATAID,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
            var result = data;
            data.VERSION = version;
            data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
            $scope.data.printResult.push(result);
            if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                trsPrintService.trsWebPrintDocument($scope.data.printResult);
                $scope.data.printResult = [];
            }
        });
    }

    /**
     * [description]隐藏
     * @return  {[type]}          [return description]
     */
    $scope.hideDraft = function() {
        $scope.status.isESSearch = false;
        var params = {
            serviceid: 'mlf_websiteoper',
            methodname: 'hidden',
            ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'RECID', ','),
            ChannelId: $stateParams.channelid,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
            function(data) {
                modalDialog.alertType('稿件隐藏成功', '', 'success', false, function() {
                    $scope.data.selectedArray = [];
                    requestData();
                });
            },
            function() {
                $scope.data.selectedArray = [];
                requestData();
            }
        );
    };

    /**
         * [atlasMode description] 图集模式
         * @return {[type]} [description]
         */
    $scope.atlasMode = function() {
        // $scope.departListParams.CurrPage = $scope.page.CURRPAGE = 1;
        $scope.status.hasphoto = !$scope.status.hasphoto;
        $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
    };

    /**
     * [description] 取消隐藏
     * @return  {[type]}          [return description]
     */
    $scope.cancelHideDraft = function() {
        $scope.status.isESSearch = false;
        var params = {
            serviceid: 'mlf_websiteoper',
            methodname: 'cancelHidden',
            ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'RECID', ','),
            ChannelId: $stateParams.channelid,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
            function(data) {
                modalDialog.alertType('稿件取消隐藏成功', '', 'success', false, function() {
                    $scope.data.selectedArray = [];
                    requestData();
                });
            },
            function() {
                $scope.data.selectedArray = [];
                requestData();
            }
        );
    };

    /**
     * [description] 关注操作弹窗
     * @return  {[type]}          [return description]
     */
    $scope.follow = function() {
        $scope.status.isESSearch = false;
        if (!checkOneType($scope.status.draftType.subject)) {
            modalDialog.alertType('只能关注专题稿', '', 'error', false);
            return;
        }
        var params = {
            serviceid: 'mlf_tag',
            methodname: 'focusonSpecial',
            MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
            modalDialog.alertType('关注成功', '', 'success', false, function() {
                requestData();
            });
        });
    };

    /**
     * [checkOneType description]所选稿件是否是统一类型
     * @param   {[type]}  typeId  [typeId description]
     * @return  {[type]}          [return description]
     */
    function checkOneType(typeId) {
        var flag = true;
        for (var i = 0; i < $scope.data.selectedArray.length; i++) {
            if ($scope.data.selectedArray[i].DOCTYPEID != typeId) {
                flag = false;
                break;
            }
        }
        return flag;
    }

    /**
     * [exportDraft description：导出稿件]
     * @return  {[type]}          [return description]
     */
    $scope.exportDraft = function() {
        $scope.status.isESSearch = false;
        if (
            checkDraftType($scope.status.draftType.subject) ||
            checkDraftType($scope.status.draftType.linkDoc) ||
            checkDraftType($scope.status.draftType.video)
        ) {
            modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', false);
            return;
        }
        var params = {
            serviceid: 'mlf_exportword',
            methodname: 'exportWordFile',
            MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
            function(data) {
                window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                $scope.data.selectedArray = [];
            },
            function(data) {
                if (data.REPORTS[0].ISSUCCESS == 'true') {
                    window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                    $scope.data.selectedArray = [];
                }
            }
        );
    };

    /**
     * [preview description]稿件预览
     *
     * @param   {[type]}  item    [item description]
     * @param   {[type]}  isOpen  [isOpen description]
     *
     * @return  {[type]}          [return description]
     */
    $scope.preview = function(item, isOpen) {
        var deffer = $q.defer();
        $scope.status.isESSearch = false;
        var params = {
            serviceid: 'mlf_website',
            methodname: 'getDocPubUrl',
            docid: item.CHNLDOCID,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            deffer.resolve(data.replace(/"/g, ''));
            if (isOpen !== false) {
                $window.open(data.replace(/"/g, ''));
            }
        });
        return deffer.promise;
    };

    /**
     * [generateQrcode description]生成二维码
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.generateQrcode = function(item) {
        $scope.preview(item, false).then(function(data) {
            editingCenterService.generateQrcode(data);
        });
    };

    /**
     * [batchGeneratingNews description]批量生成新闻
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.batchGeneratingNews = function(item) {
        editingCenterService.batchGeneratingNews('', 3);
    };

    /**
     * [batchMoveNews description]新闻批量转移
     *
     * @param   {[type]}  item  [item description]
     *
     * @return  {[type]}        [return description]
     */
    $scope.batchMoveNews = function(item) {
        editingCenterService.batchMoveNews('', 3);
    };

    /**
     * [websitePreview description] 预览页
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.websitePreview = function(item) {
        storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHNLDOCID,DOCTYPEID,CHANNELID', 'websitePreview');
    };

    /** 多元分发
     * [distribution description]
     * @return {[type]} [description]
     */
    $scope.distribution = function() {
        $scope.status.isESSearch = false;
        if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')){
            modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
            return;
        }
        var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
        if (temp.length < 1) {
            editingCenterService.distribution($scope.data.selectedArray, '2', $scope.data.selectedArray[0].DOCTYPEID, 'webYiQianFaDistribute', function() {
                $scope.data.selectedArray = [];
                requestData();
                // modalDialog.alertType("发稿单修改成功", "", "success", false, function() {
                // });
            });
        } else {
            modalDialog.alertType('', '多元分发仅支持的稿件类型为新闻、图集、视频', 'warning', 'confirm', function() {});
        }
    };

    /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
     * [examDistributionType description]
     * @param  {[type]} elm [description]
     * @return {[type]}     [description]
     */
    $scope.examDistributionType = function(elm) {
        if (angular.isDefined(elm)) {
            return elm.DOCTYPEID != 1 && elm.DOCTYPEID != 2 && elm.DOCTYPEID != 7;
        }
    };

    /**
     * [tenantManuShare 租户间共享]
     * @return {[type]} [description]
     */
    $scope.tenantManuShare = function() {
        if (!hasActiveAndSubject()) {
            modalDialog.alertType('无法进行共享', '所选稿件中包含专题稿', 'info', 'confirm', function() {});
            return;
        }
        var params = {
            serviceid: 'mlf_websiteoper',
            methodname: 'pluralisticShare',
            dataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
            ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
        };
        editingCenterService.tenantShareManu(params).then(function(data) {
            if (data == 'success') {
                requestData();
                $scope.data.selectedArray = [];
            }
        });
    };

    /**
     * [hasActiveAndSubject ]
     * @return {[type]} [description]
     */
    function hasActiveAndSubject() {
        var flag = true;
        for (var i = 0; i < $scope.data.selectedArray.length; i++) {
            if ($scope.data.selectedArray[i].DOCTYPEID == 3) {
                flag = false;
                break;
            }
        }
        return flag;
    }

    /**
     * [initFixedPos description]初始化已固定的稿件
     */
    function initFixedPos() {
        $scope.fixedPos = []; // 已经固定位置的稿件的位置集合
        angular.forEach($scope.data.items, function(item, index) {
            if (item.GDORDER > 0) {
                $scope.fixedPos.push(Number(item.GDORDER));
            }
        });
    }

    /**
     * [fixPosition 位置固定]
     */
    $scope.fixPosition = function (item, index) {
        if ($scope.data.getChannelDetail.HASCHILDREN === '1' && !$scope.params.IsCurrentChnl) {
            // 只有在当前栏目下才能位置固定
            modalDialog.alertType('请选择“只看当前栏目”', '', 'warning', false);
            return;
        }
        if (index > 15) {
            modalDialog.alertType('固定稿件操作仅限于前15个稿件', '', 'warning', false);
            return;
        }
        modalDialog.confirmModal('固定位置', '确定要固定该稿件？', function() {
            let params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'sortTopedMetaDatas',
                ChnlDocId: item.CHNLDOCID,
                OrderSort: index,
                ChannelId: $stateParams.channelid,
                BeginTime: '',
                EndTime: '',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType('固定位置成功', '', 'success', false, function() {
                    requestData();
                    initFixedPos();
                });
            });
        });
    };

    /**
     * [cancelFixed 取消固定]
     */
    $scope.cancelFixed = function(item) {
        modalDialog.confirmModal('取消固定', '确定要取消固定该稿件？', function() {
            let params = {
                serviceid: 'mlf_websiteoper',
                methodname: 'cancleTopedMetaDatas',
                ChnlDocId: item.CHNLDOCID,
                ChannelId: $stateParams.channelid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType('取消稿件固定位置成功', '', 'success', false, function() {
                    requestData();
                    initFixedPos();
                });
            });
        });
    };

    /**
     * [multiSigned description]
     *
     * @param   {[type]}  params  [params description]
     *
     * @return  {[type]}          [return description]
     */
    function multiSigned(ids) {
        var defer = $q.defer();
        var params = {
            serviceid: 'mlf_metaviewdata',
            methodname: 'queryDuoQianInfo',
            ChnlDocIds: trsspliceString.spliceString(ids, 'CHNLDOCID', ','),
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then((data) => {
            // $scope.data.ORIGINCHANNEL = data;
            defer.resolve(data);
        });
        return defer.promise;
    }
    $scope.dealMultiSignIds = function(item) {
        return item.MODAL === '2';
    };
}
